// Imports
import { withStyles } from '@material-ui/core'
import Button from '@mui/material/Button'
import Checkbox from "@mui/material/Checkbox"
import IconButton from '@material-ui/core/IconButton'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { Grid, Card, CardMedia, CardContent, CardActions, FormGroup, FormControlLabel, ToggleButtonGroup, ToggleButton, Box } from "@mui/material";
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
// UI Imports
import Toolbar from '@material-ui/core/Toolbar'
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Typography from '@material-ui/core/Typography'
import IconArrowBack from '@material-ui/icons/ArrowBack'
import dayjs from 'dayjs';
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
// App Imports
import { messageShow } from '../../common/api/actions'
import EmptyMessage from '../../common/EmptyMessage'
import Image from '../../common/Image'
import BrandedLoading from '../../common/BrandedLoading'
import SectionPaper from '../../common/SectionPaper'
import { featureToggle, publishToggle, remove } from '../api/actions/mutation'
import { detail, listByParent } from '../api/actions/query'
import routes, { getImageSource } from '../api/routes'
import styles from './styles'
import { detail as settingDetail} from "../../setting/api/actions/query";
import { checkPermission } from '../../common/Sidebar/checkPermission'

// Component
class List extends Component {

  constructor(props) {
    super(props)

    this.state = {
      category: null,
      viewMode: null,
      permissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      },
    }
  }

  componentDidMount() {
    this.refresh();
    this.verifyPermissions();
    this.fetchSettings();
  }
  verifyPermissions = async () => {
    const modulePermission = await checkPermission("store", "category");
    this.setState({permissions:{canEdit:modulePermission.canEdit,canDelete: modulePermission.canDelete,canCreate: modulePermission.canCreate,canView: modulePermission.canView}});
  };
  fetchSettings = async () => {
    const { settingDetail } = this.props;
    try {
      const { data } = await settingDetail({ vendorId: '' });
      if (data.success && data.data) {
        const viewMode = data.data.viewMode || 'grid';
        this.setState({ viewMode });
      }
    } catch (error) {
      console.error("Error fetching setting details:", error);
    }
  };
  refresh = () => {
    const { listByParent, match: { params: { categoryId } } } = this.props

    this.getCategory(categoryId)

    listByParent(categoryId)
  }

  getCategory = async (categoryId) => {
    const { detail } = this.props

    try {
      const { data } = await detail({ categoryId })

      if(data.success) {
        this.setState({
          category: data.data
        })
      }
    } catch(error) {
    }
  }

  onDelete = (categoryId) => async () => {
    let check = window.confirm('Are you sure you want to delete this category?')

    if(check) {
      const { remove, messageShow } = this.props

      try {
        const { data } = await remove({ categoryId })

        messageShow(data.message)

        if(data.success) {
          this.refresh()
        }
      } catch (error) {
        messageShow('Some error occurred. Please try again.')
      }
    }
  }

  onFeatureToggle = categoryId => async event => {
    const isFeatured = event.target.checked

    let check = window.confirm(`Are you sure you want to ${ isFeatured ? 'feature' : 'unfeature' } this category?`)

    if(check) {
      const { featureToggle, messageShow } = this.props

      try {
        const { data } = await featureToggle({ categoryId, isFeatured })

        messageShow(data.message)

        if(data.success) {
          this.refresh()
        }
      } catch (error) {
        messageShow('Some error occurred. Please try again.')
      }
    }
  }

  onPublishToggle = categoryId => async event => {
    const isPublished = event.target.checked

    let check = window.confirm(`Are you sure you want to ${ isPublished ? 'publish' : 'unpublish' } this category?`)

    if(check) {
      const { publishToggle, messageShow } = this.props

      try {
        const { data } = await publishToggle({ categoryId, isPublished })

        messageShow(data.message)

        if(data.success) {
          this.refresh()
        }
      } catch (error) {
        messageShow('Some error occurred. Please try again.')
      }
    }
  }

  back = () => {
    const { history } = this.props

    if(history.length > 2) {
      history.goBack()
    } else {
      history.push(routes.categoryList.path)
    }
  }

  render() {
    const { categoriesByParent: { isLoading, list }, classes } = this.props
    const { category,permissions, viewMode } = this.state

    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={this.back}
          >
            <IconArrowBack />
          </IconButton>

          <Typography variant="h6" color="inherit" className={classes.grow}>
            Manage Category { category && `- ${ category.name }` }
          </Typography>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={(e, newView) => {
              if (newView !== null) this.setState({ viewMode: newView });
            }}
            size="small"
            sx={{ marginRight: 2 }}
          >
            <Tooltip title="Grid View" arrow>
              <ToggleButton value="grid">
                  <ViewModuleIcon />
              </ToggleButton>
            </Tooltip>
            <Tooltip title="List View" arrow>
              <ToggleButton value="list">
                  <ViewListIcon />
              </ToggleButton>
            </Tooltip>
          </ToggleButtonGroup>
        </Toolbar>

          { viewMode === null ? (
              <BrandedLoading />
            ) : isLoading ? ( 
              <BrandedLoading />
            ) : list.length === 0 ? (
              <SectionPaper>
                <EmptyMessage message={'You have not added any sub categories yet.'} />
              </SectionPaper>
            ) : viewMode === 'grid' ?(
                <div className={classes.root}>
                  <Grid container spacing={3}>
                    {list.map(({ _id, image, name, isFeatured, isPublished, updatedAt, modifiedBy }) => (
                      <Grid item xs={12} sm={6} md={4} lg={3} key={_id} sx={{ display: 'flex' }}>
                        <Card
                          sx={{
                            width: '100%',
                            maxWidth: 400,
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            cursor: permissions.canEdit ? 'pointer' : 'default',
                          }}
                          onClick={() => permissions.canEdit && this.props.history.push(`/category/edit/${_id}`)}
                        >
                          <CardMedia
                            component="img"
                            loading="lazy"
                            image={getImageSource(image, updatedAt)}
                            onError={(e) => { 
                              e.target.src = getImageSource();  
                              e.target.style.maxHeight = '160px';
                              e.target.style.objectFit = 'contain';
                            }}
                            style={{
                              width: '100%',
                              height: '160px',
                              objectFit: 'cover',
                              flexShrink: 0,
                            }}
                            alt={name}
                          />
                          <CardContent sx={{ flex: '1 1 auto', display: 'flex', flexDirection: 'column', pb: 1 }}>
                            <Typography
                              variant="h6"
                              component="div"
                              title={name}
                              sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                minHeight: '3.2rem',
                                lineHeight: 1.25,
                                fontSize: '1.1rem',
                              }}
                            >
                              {name}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                              Updated: {dayjs(updatedAt).format('DD-MM-YYYY, hh:mm A')}
                              {modifiedBy?.name ? ` by ${modifiedBy.name}` : ''}
                            </Typography>
                          </CardContent>
                          <CardActions sx={{ mt: 'auto' }}>
                            <Tooltip title="Delete">
                              <IconButton
                                onClick={(e) => { e.stopPropagation(); this.onDelete(_id)(); }}
                                disabled={!permissions.canDelete}
                              >
                                <DeleteIcon color="error"/>
                              </IconButton>
                            </Tooltip>
                            <FormGroup row>
                              <FormControlLabel
                                control={
                                <Checkbox
                                  onClick={(e) => e.stopPropagation()}
                                  checked={isFeatured}
                                  onChange={permissions.canEdit && this.onFeatureToggle(_id)}
                                  disabled={!permissions.canEdit}
                                />
                              }
                              label="Featured"
                             />
                             <FormControlLabel
                              control={
                                <Checkbox
                                  onClick={(e) => e.stopPropagation()}
                                  checked={isPublished}
                                  onChange={permissions.canEdit && this.onPublishToggle(_id)}
                                  disabled={!permissions.canEdit}
                                />
                              }
                              label="Published"
                              />
                            </FormGroup>
                          </CardActions>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </div>
              ) :(
                <SectionPaper>
                 <Table padding={"normal"}>
                    <TableHead>
                      <TableRow>
                        <TableCell width={85}>Image</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell width={180}>Updated</TableCell>
                        <TableCell width={80} align="center">Featured</TableCell>
                        <TableCell width={80} align="center">Published</TableCell>
                        <TableCell width={180} align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {
                        list.map(({ _id, image, name, isFeatured, isPublished, updatedAt, modifiedBy }) =>
                          <TableRow key={_id}>
                            <TableCell>
                              {permissions.canEdit ? (
                                <Link to={routes.categoryEdit.path(_id)}>
                                  <Image
                                    src={getImageSource(`${image}`, updatedAt)}
                                    defaultSrc={getImageSource()}
                                  />
                                </Link>
                              ) : (
                                <Image
                                  src={getImageSource(`${image}`, updatedAt)}
                                  defaultSrc={getImageSource()}
                                />
                              )}
                            </TableCell>
                            <TableCell>{ name }</TableCell>
                            <TableCell>{dayjs(updatedAt).format('DD-MM-YYYY, hh:mm A')}{modifiedBy?.name ? ` by ${modifiedBy.name}` : ''}</TableCell>
                            <TableCell align="center">
                              <Checkbox
                                checked={isFeatured}
                                onChange={permissions.canEdit && this.onFeatureToggle(_id)}
                                disabled={!permissions.canEdit}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Checkbox
                                checked={isPublished}
                                onChange={permissions.canEdit && this.onPublishToggle(_id)}
                                color="primary"
                                disabled={!permissions.canEdit}
                              />
                            </TableCell>
                            <TableCell align="center">
                            <Tooltip title="Edit" arrow>
                              <Button color="primary" component={Link} to={routes.categoryEdit.path(_id)} disabled={!permissions.canEdit}><EditIcon /></Button>
                            </Tooltip>
                            <Tooltip title="Delete" arrow>
                              <Button color="error" onClick={this.onDelete(_id)} disabled={!permissions.canDelete}><DeleteIcon /></Button>
                            </Tooltip>
                            </TableCell>
                          </TableRow>
                        )
                      }
                    </TableBody>
                 </Table>
              </SectionPaper>
              )
          }
      </div>
    )
  }
}

// Component Properties
List.propTypes = {
  categoriesByParent: PropTypes.object.isRequired,
  listByParent: PropTypes.func.isRequired,
  detail: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  featureToggle: PropTypes.func.isRequired,
  publishToggle: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  settingDetail: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

// Component State
function listState(state) {
  return {
    categoriesByParent: state.categoriesByParent
  }
}

export default connect(listState, { listByParent, detail, remove, featureToggle, publishToggle, messageShow, settingDetail })(withStyles(styles)(List))
